import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=8255ea04&scoped=true"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js"
import style0 from "./DashboardAdmin.vue?vue&type=style&index=0&id=8255ea04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8255ea04",
  null
  
)

export default component.exports